if (!customElements.get("alcohol-terms")) {
  customElements.define(
    "alcohol-terms",
    class AlcoholTerms extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        // Add your HTML content here
        this.innerHTML = `
        <div style="font-size:0.9rem">          
            <p>Springbok Foods operates from premises situated in Queensland and all sales are subject to the Liquor Act 1992 (QLD) and other relevant Queensland Laws. Under the Liquor Act 1992 (QLD) it is an offence to supply alcohol to any person under the age of 18 years of age. The maximum penalty for supplying liquor to a minor is $25,000. For any person under the age of 18 years of age purchasing or receiving liquor the maximum penalty is $2,500. By proceeding, clicking on and purchasing any alcohol products you warrant that your are 18 years or older and are legally entitled to purchase alcohol. We record all IP addresses and personal details of users purchasing through this website and they will be handed over to the Queensland Police Service or Office of Liquor & Gaming Regulation authorities if obliged to under Queensland Law.</p>
        
            <p><strong>Do NOT proceed if you are unsure of your legal entitlement to purchase alcohol under Queensland law.</strong></p>
        
            <p><strong>ALL RETAIL ALCOHOL PURCHASES ARE SUBJECT TO OUR LICENSE RESTRICTIONS UNDER QUEENSLAND LAW AND WE RETAIN THE RIGHT TO AMEND OR CANCEL YOUR ORDER SO AS TO COMPLY WITH THE LIQUOR LICENSE REGULATIONS. UNDER NO CIRCUMSTANCES WILL ANY EXCEPTIONS BE MADE.</strong></p>
        
            <p>Our current LIQUOR LICENSE regrettably restricts the sale of alcohol AS PART OF A GIFT BASKET containing a selection of other products. To ensure your order reflects this requirement a mandatory gift bag will be added for a fee of $0.25c</p>

          
            <p>
            <div style="font-size:1rem; margin:0; padding:0.3rem; width:100%; background-color:lightgrey;">
            <ul>
              <li>QLD Liquor Licence restricts alcohol to 75% of your cart total</li>
              <li>Liquor is limited per transaction to a maximum of 9 litres of beer, cider or wine</li>
              <li>2 litres of all other types of liquor</li>
            </ul>
            </div>    
            <br/>
            For example you are allowed to purchase a case of beer at $45.00 together with a minimum of $15 of grocery and/or meat products. Note that this is a Queensland Liquor license restriction and not a rule we have made up to force you to buy more groceries...although that wouldn't be such a bad thing now would it! :-)</p>
        
            <p>Should you have a Liquor License in any Australian State or Territory (or another relevant exemption) and wish to purchase larger quantities of alcohol than our license allows then please contact us about purchasing through our wholesale license.</p>
        
            <p><em>PLEASE CALL US TO CLARIFY THESE RESTRICTIONS IF YOU ARE UNFAMILIAR WITH THEM OR DO NOT UNDERSTAND THEM.</em></p>
        
            <p>Liquor License Numbers: Wholesale:49403640 and Retail:46106423</p>

            <button id="acknowledgeButton" class="button button--secondary">I Acknowledge</button>
        </div>
      `;

        // Add event listener to the button
        this.querySelector("#acknowledgeButton").addEventListener(
          "click",
          () => {
            setCookie("hasAcknowledged", true, 365); // Cookie expires after 1 year
            this.hide();
          }
        );

        super.show(opener);
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", (event) => {
  const isAlcoholic = document.getElementById("isAlcoholic")?.value ?? false;
  const hasAcknowledged = getCookie("hasAcknowledged");
    // Get the current URL
  const url = window.location.href;

  // List of terms to look for in the URL
  const urlTerms = ['spirits', 'ciders', 'wine', 'beer', 'fortified', 'liqueur', 'spirit-mixers'];
  
  // Check if any of the terms are in the URL  
  const urlContainsTerm = urlTerms.some(term => url.toLowerCase().includes(term));

  // Check if the product is alcoholic and the user hasn't acknowledged the terms
  if (isAlcoholic === "true" && !hasAcknowledged) {
    const modal = document.querySelector("alcohol-terms");
    if (modal) modal.show();
  }
  else if (urlContainsTerm && !hasAcknowledged) {
    const modal = document.querySelector("alcohol-terms");
    if (modal) modal.show();
  }
});

// Function to set a cookie
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Function to get a cookie
function getCookie(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
